export enum TopCalendarMode {
  TODAY = "TODAY",
  TOMORROW = "TOMORROW",
  YESTERDAY = "YESTERDAY",
  WEEKEND = "WEEKEND",
  WEEK = "WEEK",
  LAST_WEEK = "LAST_WEEK",
  NEXT_7_DAYS = "NEXT_7_DAYS",
  MONTH = "MONTH",
  LAST_MONTH = "LAST_MONTH",
  LAST_30_DAYS = "LAST_30_DAYS",
  CUSTOM = "CUSTOM",
}

export const TOP_CALENDAR_MODES: TopCalendarMode[] = [
  TopCalendarMode.TODAY,
  TopCalendarMode.TOMORROW,
  TopCalendarMode.YESTERDAY,
  TopCalendarMode.WEEKEND,
  TopCalendarMode.WEEK,
  TopCalendarMode.LAST_WEEK,
  TopCalendarMode.NEXT_7_DAYS,
  TopCalendarMode.MONTH,
  TopCalendarMode.LAST_MONTH,
  TopCalendarMode.LAST_30_DAYS,
  TopCalendarMode.CUSTOM,
];
